<template>
  <div class="language-switcher" ref="switcherRef">
    <button class="lang-button" @click="toggleDropdown" :title="$t('language.switch')">
      <span class="current-flag">{{ currentLanguage.flag }}</span>
      <span class="current-name">{{ currentLanguage.code.toUpperCase() }}</span>
      <span class="arrow" :class="{ open: isOpen }">▼</span>
    </button>
    <div class="dropdown" v-show="isOpen">
      <button 
        v-for="lang in languages" 
        :key="lang.code"
        class="dropdown-item"
        :class="{ active: lang.code === currentLanguage.code }"
        @click="selectLanguage(lang.code)"
      >
        <span class="flag">{{ lang.flag }}</span>
        <span class="name">{{ lang.name }}</span>
        <span class="check" v-if="lang.code === currentLanguage.code">✓</span>
      </button>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { setLanguage, getAvailableLanguages, state } from '@/i18n'

export default {
  name: 'LanguageSwitcher',
  setup() {
    const isOpen = ref(false)
    const switcherRef = ref(null)
    const languages = getAvailableLanguages()
    
    const currentLanguage = computed(() => {
      return languages.find(lang => lang.code === state.currentLang) || languages[0]
    })
    
    const toggleDropdown = () => {
      isOpen.value = !isOpen.value
    }
    
    const selectLanguage = (code) => {
      setLanguage(code)
      isOpen.value = false
      // 强制刷新页面以更新所有内容
      location.reload()
    }
    
    // 点击外部关闭下拉菜单
    const handleClickOutside = (event) => {
      if (switcherRef.value && !switcherRef.value.contains(event.target)) {
        isOpen.value = false
      }
    }
    
    onMounted(() => {
      document.addEventListener('click', handleClickOutside)
    })
    
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside)
    })
    
    return {
      isOpen,
      switcherRef,
      languages,
      currentLanguage,
      toggleDropdown,
      selectLanguage
    }
  }
}
</script>

<style scoped>
.language-switcher {
  position: relative;
}

.lang-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: var(--text-primary);
}

.lang-button:hover {
  background: var(--bg-hover);
}

.current-flag {
  font-size: 16px;
}

.current-name {
  font-weight: 500;
}

.arrow {
  font-size: 10px;
  transition: transform 0.2s;
  color: var(--text-secondary);
}

.arrow.open {
  transform: rotate(180deg);
}

.dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 140px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  z-index: 1000;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-primary);
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: var(--bg-hover);
}

.dropdown-item.active {
  background: var(--accent-light);
}

.flag {
  font-size: 18px;
}

.name {
  flex: 1;
  text-align: left;
}

.check {
  color: var(--accent-color);
  font-weight: bold;
}

@media (max-width: 768px) {
  .current-name {
    display: none;
  }
  
  .lang-button {
    padding: 8px 10px;
  }
}
</style>
